import { forwardRef, type ReactNode } from "react";
import * as styles from "./styles.module.scss";

const LegalContentItem = forwardRef<HTMLDivElement, { children: ReactNode; title: string; id?: string | undefined }>(
    ({ children, title, id }, ref) => {
        return (
            <div className="mb-5" ref={ref} id={id}>
                <div className={["figma-h2", styles.text_black, "mb-3"].join(" ")}>{title}</div>
                <div className={styles.text_black}>{children}</div>
            </div>
        );
    }
);

LegalContentItem.displayName = "LegalContentItem";

export default LegalContentItem;
